<template>
	
	<div>
		
		<div class="editor" :class="{ 'editor--editable': editable }">
			
			<div v-if="editable" class="editor__title-bar">
				
				<editor-menu-bar :editor="editor">
					
					<div class="editor__menu" slot-scope="{ commands, isActive, getMarkAttrs }">
						<button class="menu__button" :class="{ 'is-active': isActive.heading({ level: 1 }) }" @click.prevent="commands.heading({ level: 1 })">H1</button>
						<button class="menu__button" :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click.prevent="commands.heading({ level: 2 })">H2</button>
						<button class="menu__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 3 })">H3</button>
						<button class="menu__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold"><i class="fas fa-bold"></i></button>
						<button class="menu__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic"><i class="fas fa-italic"></i></button>
						<button class="menu__button" :class="{ 'is-active': isActive.strike() }" @click.prevent="commands.strike"><i class="fas fa-strikethrough"></i></button>
						<button class="menu__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline"><i class="fas fa-underline"></i></button>
						<span class="menu__divider"></span>
						<button class="menu__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list"><i class="fas fa-list-ul"></i></button>
						<button class="menu__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list"><i class="fas fa-list-ol"></i></button>
						<!--<button class="menu__button" :class="{ 'is-active': isActive.todo_list() }" @click.prevent="commands.todo_list"><i class="fas fa-tasks"></i></button>-->
						<span class="menu__divider"></span>
						<button class="menu__button" :class="{ 'is-active': isActive.link() }" @click.prevent="onClickAddLink(getMarkAttrs('link'), commands.link)"><i class="fas fa-link"></i></button>
						<span class="menu__divider"></span>
						<button class="menu__button" :class="{ 'is-active': isActive.code() }" @click.prevent="commands.code"><i class="fas fa-code"></i></button>
						<button class="menu__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote"><i class="fas fa-quote-right"></i></button>
						<button class="menu__button" @click.prevent="onClickAddImage(commands.image)"><i class="fas fa-image"></i></button>
					</div>
					
				</editor-menu-bar>
				
			</div>
			
			<editor-content class="editor__content" :editor="editor"/>
			
		</div>
		
		<el-dialog class="el-dialog__wrapper--deeper" :title="urlPopup.title" :visible.sync="urlPopup.visible" width="480px">
			
			<el-form :model="urlPopup">
				<el-form-item label="URL">
					<el-input v-model="urlPopup.url"></el-input>
				</el-form-item>
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button v-for="(button, i) in urlPopup.buttons" :type="button.type" @click="urlPopup.callback(button.action)" :key="i">{{ button.label }}</el-button>
				<!--<el-button @click="urlPopup.callback('cancel')">Cancel</el-button>
				<el-button type="primary" @click="urlPopup.callback('confirm')">Save</el-button>-->
			</span>
			
		</el-dialog>
		
	</div>
	
</template>

<script>
	
	import { Editor, EditorContent, EditorMenuBar } from "tiptap";
	
	import {
		Placeholder,
		Heading,
		Bold,
		Italic,
		Strike,
		Underline,
		OrderedList,
		BulletList,
		ListItem,
		TodoItem,
		TodoList,
		Link,
		Code,
		Blockquote,
		Image
	} from "tiptap-extensions";
	
	//import Iframe from "@/components/TextEditor/Extensions/Iframe.js";
	//import TodoItem from "@/components/TextEditor/Extensions/TodoItem.js";
	//import TodoList from "@/components/TextEditor/Extensions/TodoList.js";
	
	export default {
		
		props: [ "editable", "title", "content" ],
		
		components: { EditorContent, EditorMenuBar },
		
		methods: {
			
			onClickAddLink(attrs, command) {
				
				let url = "";
				let buttons = [ { action: "insert", type: "primary", label: "Insert" } ];
				
				if (attrs.href) {
					url = attrs.href;
					buttons.unshift({ action: "remove", type: "danger", label: "Remove" });
				}
				
				this.$set(this, "urlPopup", {
					visible: true,
					title: "Insert Link",
					url: url,
					buttons: buttons,
					callback: (action) => {
						this.urlPopup.visible = false;
						if (action == "remove") {
							command({ href: null });
						} else if (action == "insert") {
							command({ href: this.urlPopup.url });
						}
					},
				});
				
			},
			
			onClickAddImage(command) {
				
				this.$set(this, "urlPopup", {
					visible: true,
					title: "Image URL",
					url: "",
					buttons: [ { action: "insert", type: "primary", label: "Insert" } ],
					callback: (action) => {
						this.urlPopup.visible = false;
						if (action == "insert") {
							command({ src: this.urlPopup.url });
						}
					},
				});
				
			},
			
			getContent(json) {
				if (json) {
					return this.editor.getJSON();
				}
				return this.editor.getHTML();
			},
			
			setContent(content) {
				this.editor.setContent(content);
			}
			
		},
		
		/*
			Data
		*/
		
		data() {
			
			return {
				
				editor: null,
				
				urlPopup: {
					visible: false,
					title: "",
					url: "",
				},
				
			}
			
		},
		
		/*
			Lifecycle
		*/
		
		mounted() {
			
			this.editor = new Editor({
				content: this.content,
				editable: this.editable,
				extensions: [
					new Placeholder({
						emptyNodeText: "Task description...",
						showOnlyWhenEditable: true,
					}),
					new Heading(),
					new Bold(),
					new Italic(),
					new Strike(),
					new Underline(),
					new OrderedList(),
					new BulletList(),
					new ListItem(),
					new TodoItem(),
					new TodoList(),
					new Link(),
					new Code(),
					new Blockquote(),
					new Image(),
					//new Iframe(),
				],
			});
			
		},
		
		beforeDestroy() {
			this.editor.destroy();
	    },
		
	}
	
</script>

<style lang="scss">
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/TextEditor.vue